import { AccountGotoAction, AccountNavigationExtras } from '../account-router';

export class AuthenticateEmail {
  static readonly type = '[EmailAuthentication] Authenticate email';
  constructor(public email: string, public overwriteRedirectUrl?: string, public isAutoInit: boolean = false) {}
}

export class VerifyEmailAuthentication {
  static readonly type = '[EmailAuthentication] Check if authentication email was verified';
  constructor(public timeoutInMilliseconds: number) {}
}

export class ResendAuthenticationEmail {
  static readonly type = '[EmailAuthentication] Resend authentication email';
}

export class CompleteEmailAuthentication {
  static readonly type = '[EmailAuthentication] Complete email authentication';
}

export class CancelEmailAuthentication {
  static readonly type = '[EmailAuthentication] Cancel email authentication';
}

export class GotoVerifyEmail extends AccountGotoAction {
  static readonly type = '[EmailAuthentication] Goto verify email';
}

export class GotoRegistrationComplete<T extends AccountNavigationExtras = AccountNavigationExtras> extends AccountGotoAction<T> {
  static readonly type = '[EmailAuthentication] Goto registration complete';
}
